const mainBody = document.body


//detect when mobile
function isMobileOrTablet() {
    return window.matchMedia('(max-width: 1023px)').matches
}

//function to wait for any element chosen by query, when element appears it is returned
function waitForElement(query, autoDisconnect = true) {

    return new Promise((resolve) => {

        let awaitedElement = mainBody.querySelector(query)
        if (awaitedElement) return resolve(awaitedElement);

        const observer = new MutationObserver(() => {


            awaitedElement = mainBody.querySelector(query)

            if (awaitedElement) {
                disconnectAndResolve()
            }

        });

        observer.observe(mainBody, {
            childList: true,
            subtree: true
        });


        function disconnectAndResolve(hasElement = true) {
            observer.disconnect();
            return hasElement ? resolve(awaitedElement) : resolve(null);
        }

        if (autoDisconnect) {
            //if no container is detected in 5 seconds, disconnect observer and resolve promise returning null
            setTimeout(() => {
                disconnectAndResolve(false)
            }, 5000)
        }
    });
}

//standard lazy loading for images main function
function lazyLoading() {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {

                    let lazyImage = entry.target;

                    loadLazyImg(lazyImage)
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }
}

//add mouseover listener for lazy load on hover function
function hoverLazyLoading() {
    let lazyOnHoverImages = [].slice.call(document.querySelectorAll("img.lazy-on-hover"));

    lazyOnHoverImages.forEach((lazyHoverImg) => {
        lazyHoverImg.closest('.lazy-hover-container').addEventListener('mouseover', loadLazyImgOnHover, {once: true})
    })
}

//function to lazy load on hover
function loadLazyImgOnHover(evt) {

    let eTarget = evt.target
    if (!eTarget.classList.contains('lazy-hover-container')) eTarget = eTarget.closest('.lazy-hover-container')

    let lazyImg = eTarget.querySelector('.lazy-on-hover')

    loadLazyImg(lazyImg)
}

//lazy load function for images
function loadLazyImg(lazyImgEl) {

    lazyImgEl.src = lazyImgEl.dataset.src;
    lazyImgEl.srcset = lazyImgEl.dataset.srcset;
    setTimeout(() => {
        lazyImgEl.classList.remove("lazy");
        lazyImgEl.parentElement.classList.remove('loading')
    })
}

function customAnimate(el) {
    el.classList.add(el.dataset.animation)
}

function customAnimateOnScroll() {
    let allAnimatedElements = document.querySelectorAll('[data-animation]')
    let counter = 0

    let observerCallback = (entries, observer) => {

        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                customAnimate(entry.target)
                observer.observe(entry.target)
                counter++

                if (counter === allAnimatedElements.length) {
                    observer.disconnect()
                }
            }
        })
    }

    let observer = new IntersectionObserver(observerCallback);

    allAnimatedElements.forEach((el) => {

        observer.observe(el)
    })
}

function removeAllCustomAnimations() {

    let allAnimatedElements = document.querySelectorAll('[data-animation]')
    allAnimatedElements.forEach(el => {
        el.removeAttribute('data-animation')
    })
}

//all custom widget basic and shared functions
const customWidgetFunctions = {

    //detect widget smart tab container on page
    async getSmartTabContainer(widgetEl, widgetType) {
        //if product page
        if (mainBody.dataset.template === 'product') {

            //wait for smart tabs and get container
            let smartTabs = await waitForElement('.smart-tabs-wrapper', false)

            if (smartTabs) {
                customWidgetFunctions.assignWidgetContainer(widgetEl, smartTabs, widgetType)
                if (widgetEl.container) widgetEl.container.innerHTML = ''
            }

        }
    },
    //detect widget container
    assignWidgetContainer(widgetEl, parent, widgetType) {
        widgetEl.container = parent.querySelector('div[data-custom-element=' + widgetType + ']')
    },
    //append widget to detected container
    appendWidget(widgetEl) {
        widgetEl.container.append(widgetEl)
    },
    //show widget
    showWidget(widgetEl) {
        widgetEl.classList.remove('mf-hide')
    },
    //check if widget is active
    widgetIsActive(widgetEl) {
        return widgetEl.classList.contains('js-activate')
    },
    //hide tab
    hideTab(widgetEl) {

        const tabNumber = widgetEl.container.parentElement.id[widgetEl.container.parentElement.id.length - 1]
        const tabHeading = document.querySelector(`[data-tab-link-id="${tabNumber}"]`)
        tabHeading.style.display = 'none'
    }

}

/*//custom sizes widget definition
class CustomSizesWidget extends HTMLElement {
    constructor() {
        super();

        if (customWidgetFunctions.widgetIsActive(this)) {
            customWidgetFunctions.getSmartTabContainer(this, 'custom-sizes-widget').then(() => {
                    if (this.container) customWidgetFunctions.appendWidget(this)
                    customWidgetFunctions.showWidget(this)
                }
            )
        }
    }
}

customElements.define('custom-sizes-widget', CustomSizesWidget)*/

//custom finishes widget definition
class CustomFinishesWidget extends HTMLElement {
    constructor() {
        super();

        if (customWidgetFunctions.widgetIsActive(this)) {

            this.linkButtonsToContainers()

            customWidgetFunctions.getSmartTabContainer(this, 'custom-finishes-widget').then(() => {
                    if (this.container) customWidgetFunctions.appendWidget(this)
                    customWidgetFunctions.showWidget(this)
                }
            )
        }

    }

    //link buttons to relative options container and listen for click event
    linkButtonsToContainers() {

        this.categoryButtons = this.querySelectorAll('[data-finishes-category]')
        this.optionsContainers = this.querySelectorAll('[data-finishes-options]')

        this.optionsContainers.forEach((container) => {
            container.category = container.dataset.finishesOptions
        })

        this.categoryButtons.forEach((button) => {
            button.category = button.dataset.finishesCategory
            button.addEventListener('click', (evt) => {
                evt.preventDefault()

                if (!button.classList.contains('active')) this.switchCategory(button)

            })
        })
    }

    //switch between categories
    switchCategory(button) {

        this.categoryButtons.forEach((genericButton) => {
            if (genericButton !== button) {
                genericButton.classList.remove('active')
            } else {
                genericButton.classList.add('active')
            }
        })

        setTimeout(() => {
            this.optionsContainers.forEach((container) => {
                if (container.category === button.category) {
                    container.classList.add('active')
                } else {
                    container.classList.remove('active')
                }
            })
        }, 300)

    }

}

customElements.define('custom-finishes-widget', CustomFinishesWidget)

//custom delivery time widget
class CustomDeliveryTimeWidget extends HTMLElement {
    constructor() {
        super();

        customWidgetFunctions.assignWidgetContainer(this, document, 'custom-delivery-time-widget')
        customWidgetFunctions.appendWidget(this);
    }

}

customElements.define('custom-delivery-time-widget', CustomDeliveryTimeWidget)

//custom product details widget definition
class CustomDetailsWidget extends HTMLElement {
    constructor() {
        super();

        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-details-widget').then(() => {
                    if (this.container) {

                        this.tableHasData = Array.from(this.children).some(child => child.children.length > 0);
                        if (!this.tableHasData) {
                            customWidgetFunctions.hideTab(this)
                        } else {
                            customWidgetFunctions.appendWidget(this)
                            //show details widget only if a smart tabs container is present
                            customWidgetFunctions.showWidget(this)
                        }
                    }

                }
            )
        }

        this._onVariantChangedListener = this._onVariantChanged.bind(this);
        const allForms = [...document.forms]
        const productForm = allForms.find(form => form.action.includes('cart/add'))
        productForm?.addEventListener("variant:change", this._onVariantChangedListener);

    }

    _onVariantChanged(event) {
        const variantId = event.detail.variant ? event.detail.variant["id"] : null;
        Array.from(this.children).forEach((item) => item.toggleAttribute("hidden", variantId !== parseInt(item.getAttribute("data-variant-id"))));
    }

}

customElements.define('custom-details-widget', CustomDetailsWidget)

//custom product downloads widget
class CustomProductDownloads extends HTMLElement {
    constructor() {
        super();

        //if smart tab is present:
        // If files are uploaded or linked, append to the container and show the widget,
        // Otherwise hide smart tab
        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-product-downloads').then(async () => {
                    if (this.container) {
                        this.fileNodes = this.querySelectorAll('.download-module')
                        for (const fileNode of this.fileNodes) { // Use for...of loop for async/await
                            fileNode.link = fileNode.querySelector('a');
                            if (fileNode.link.href.includes('youtu')) {
                                fileNode.fileTitle = await this.fetchTitle(fileNode.link.href); // 'await' works here
                                fileNode.extension = 'video';
                                fileNode.link.innerText = 'Watch';
                            } else {
                                fileNode.completeName = this.generateCompleteFileName(fileNode.link.href);
                                fileNode.fileTitle = this.getTitle(fileNode.completeName);
                                fileNode.extension = this.getFileExtension(fileNode.completeName);
                            }

                            const typeEl = fileNode.querySelector('.download-module__type')
                            const titleEl = fileNode.querySelector('.download-module__title')
                            //const sizeEl = fileNode.querySelector('.download-module__size span')

                            typeEl.innerHTML = fileNode.extension
                            titleEl.innerHTML = fileNode.fileTitle
                            //this.getFileSize(fileNode.link.href, sizeEl)
                        }

                        if (this.fileNodes.length) {
                            customWidgetFunctions.appendWidget(this)
                            //show details widget only if a smart tabs container is present
                            customWidgetFunctions.showWidget(this)
                        } else {
                            customWidgetFunctions.hideTab(this)
                        }
                    }
                }
            )
        }

    }

    getFileSize(link, sizeNode) {
        fetch(link, {
            mode: "no-cors"
        }).then(r => r.blob()).then(blobObj => {
            const sizeData = blobObj.size
            let sizeString
            if (sizeData >= 1000000) {
                sizeString = (sizeData / 1000000).toFixed(2) + ' MB'
            } else {
                sizeString = (sizeData / 1000).toFixed(2) + ' KB'
            }
            sizeNode.innerHTML = sizeString
        })
    }

    //generate file name with extension included
    generateCompleteFileName(url) {
        const start = url.lastIndexOf('/')

        let end
        if (url.includes('?')) end = url.indexOf('?')
        else end = url.length
        return url.substring(start + 1, end)
    }

    //get only file title
    getTitle(completeFileName) {
        const lastDotIndex = completeFileName.lastIndexOf('.')

        let title
        if (completeFileName.includes('_')) title = completeFileName.substring(0, completeFileName.indexOf('_'))
        else title = completeFileName

        return title.substring(0, lastDotIndex).replaceAll('-', ' ')
    }

    //get file extension
    getFileExtension(completeFileName) {
        const lastDotIndex = completeFileName.lastIndexOf('.')
        return completeFileName.substring(lastDotIndex + 1)
    }

    async fetchTitle(url) {
        const query = `https://www.youtube.com/oembed?url=${url}&format=json`

        let title = ''
        await fetch(query).then(response => response.json()).then((data) => {
            title = data.title
        })

        return title
    }

}

customElements.define('custom-product-downloads', CustomProductDownloads)

//custom product videos widget
class CustomProductVideos extends HTMLElement {
    constructor() {
        super();

        //if smart tab is present:
        // If files are uploaded or linked, append to the container and show the widget,
        // Otherwise hide smart tab
        if (customWidgetFunctions.widgetIsActive(this)) {

            customWidgetFunctions.getSmartTabContainer(this, 'custom-product-videos').then(async () => {
                    if (this.container) {
                        this.fileNodes = this.querySelectorAll('iframe')

                        if (this.fileNodes.length) {
                            customWidgetFunctions.appendWidget(this)
                            //show details widget only if a smart tabs container is present
                            customWidgetFunctions.showWidget(this)
                        } else {
                            customWidgetFunctions.hideTab(this)
                        }
                    }
                }
            )
        }

    }

}

customElements.define('custom-product-videos', CustomProductVideos)

//custom minimum order widget definition
class CustomMinimumOrderWidget extends HTMLElement {
    constructor() {
        super();
        this.overlay = this.querySelector('.custom-minimum-order-widget__container')
        this.minusButton = this.parentElement.querySelector('.quantity-selector__button.minus, .quantity-selector__button[name="minus"]')
        this.numberInput = this.parentElement.querySelector('.quantity-selector__input')
        this.moqString = this.querySelector('.moq-string')

        this.minimumQuantity = Number(this.dataset.moq) || this.numberInput.min

        //update numeric input value if less than moq
        if (Number(this.numberInput.value) < this.minimumQuantity) this.numberInput.value = this.minimumQuantity

        this.boundConditionalClose = this.conditionalClose.bind(this);


        // Bind the closeOverlay method and store the reference
        this.boundCloseOverlay = this.closeOverlay.bind(this);

        this.minusButton.addEventListener('click', (event) => {
            //refresh minimum quantity in case dynamic content is provided
            this.minimumQuantity = Number(this.dataset.moq) || this.numberInput.min
            if (Number(this.numberInput.value) < this.minimumQuantity) this.numberInput.value = this.minimumQuantity

            if (this.moqString.innerText !== this.minimumQuantity) this.moqString.innerText = this.minimumQuantity

            if (Number(this.numberInput.value) === this.minimumQuantity) {
                event.stopImmediatePropagation();
                if (!this.overlay.classList.contains('show')) {
                    this.showOverlay()
                    setTimeout(() => document.addEventListener('click', (evt) => {
                        if (evt.target !== this.minusButton && !evt.target.closest('.quantity-selector__button.minus')) {
                            this.boundCloseOverlay()
                        }
                    }))
                }
            }

        }, true)
    }

    showOverlay() {
        this.overlay.classList.add('show')
        this.closeTimeoutId = setTimeout(this.boundCloseOverlay, 8000)

        // Add the conditional close event listener to the document
        setTimeout(() => document.addEventListener('click', this.boundConditionalClose));
    }

    closeOverlay() {
        this.overlay.classList.remove('show')
        // Clear the timeout to prevent it from running if the overlay is already closed
        if (this.closeTimeoutId) {
            clearTimeout(this.closeTimeoutId);
        }

        // Remove the conditional close event listener from the document
        document.removeEventListener('click', this.boundConditionalClose);
    }

    conditionalClose(evt) {
        if (!evt.target.closest('.quantity-selector__button.minus')) {
            this.boundCloseOverlay();
        }
    }

}

customElements.define('custom-minimum-order-widget', CustomMinimumOrderWidget)


//append vat label to price container via JS for layout purposes on mobile
class VatLabel extends HTMLElement {
    constructor() {
        super();

        this.priceReference = this.closest('.loop-price-container').querySelector('sale-price')
        this.priceReference.append(this)
    }
}
customElements.define('vat-label', VatLabel)

document.addEventListener("DOMContentLoaded", () => {
    if (mainBody.dataset.template === 'product') {
        waitForElement('.smart-tabs-wrapper', false).then(() => {

                // hide loader when smart tabs kicks in
                const smartTabsLoader = mainBody.querySelector('.smart-tabs-custom-loader')
                smartTabsLoader.classList.add('mf-hide')

                lazyLoading()
                if (!isMobileOrTablet()) hoverLazyLoading()
            }
        )
    } else {
        lazyLoading()
    }
    //when page gets visible
    if (mainBody.classList.contains('page-transition')) {
        window.addEventListener('pageshow', () => {
            //kick in animations when element enters viewport
            customAnimateOnScroll()
        })
    } else {
        customAnimateOnScroll()
    }
})